import React from 'react';
import { Backdrop, Box, Typography, Chip } from '@mui/material';
import DisplayMedia from '../components/DisplayMedia';
import { useTheme } from '../context/PermissionsContext/ThemeContext/ThemeContext';

export default function ImageCarousel(props) {
  const {
    showImageCarousel,
    setShowImageCarousel,
    imagesArr,
    imageIndex,
    setImageIndex,
    zIndex,
    photos = [], // Add photos prop for tag data
    isVideoFile, // Add isVideoFile helper function
  } = props;

  const { theme } = useTheme();

  // Get current photo data for tags
  const currentPhoto = photos[imageIndex] || null;

  return (
    <Backdrop
      sx={{ zIndex }}
      open={showImageCarousel}
      onClick={(e) => {
        e.stopPropagation();
        if (!e.target.closest('.navigation-button')) {
          setShowImageCarousel(false);
        }
      }}
    >
      <Box style={{ display: 'flex', height: '75vh' }}>
        {imagesArr.length > 0 && (
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              marginRight: 16,
            }}
          >
            <Box
              className={'navigation-button'}
              style={{
                backgroundColor: 'white',
                width: 30,
                height: 30,
                borderRadius: 1000,
              }}
              sx={{ cursor: imageIndex !== 0 ? 'pointer' : 'default' }}
              onClick={() => {
                if (imageIndex !== 0) setImageIndex(imageIndex - 1);
              }}
            >
              <img
                src={
                  imageIndex > 0
                    ? '/images/previous-page.svg'
                    : '/images/previous-page-disabled.svg'
                }
                style={{ height: '30px' }}
              />
            </Box>
          </Box>
        )}
        <Box
          style={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'black',
            borderRadius: '8px',
            padding: '16px',
          }}
        >
          <Box
            style={{
              position: 'relative',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <DisplayMedia
              imageName={imagesArr[imageIndex]}
              imageType={
                isVideoFile && isVideoFile(imagesArr[imageIndex])
                  ? 'video'
                  : 'img'
              }
              height={'100%'}
              width={'450px'}
              objectFit={'contain'}
              borderRadius={'0px'}
            ></DisplayMedia>
            <Box
              style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                padding: '8px 12px',
                borderRadius: 16,
              }}
            >
              <Typography style={{ color: 'white', fontSize: '14px' }}>
                {`${imageIndex + 1} of ${imagesArr.length}`}
              </Typography>
            </Box>
          </Box>

          {/* Tags display below image - like mobile */}
          {currentPhoto &&
            currentPhoto.tags &&
            currentPhoto.tags.length > 0 && (
              <Box
                style={{
                  marginTop: 16,
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 8,
                  justifyContent: 'center',
                  maxWidth: '450px',
                }}
              >
                {currentPhoto.tags.map((tag, idx) => (
                  <Chip
                    key={`${tag}-${idx}`}
                    label={tag}
                    size="small"
                    sx={{
                      backgroundColor: theme.primary,
                      color: 'white',
                      fontSize: '12px',
                      height: '24px',
                      '& .MuiChip-label': {
                        padding: '0 8px',
                      },
                    }}
                  />
                ))}
              </Box>
            )}

          {/* Description display - like mobile */}
          {currentPhoto &&
            currentPhoto.description &&
            currentPhoto.description !== 'Photo' && (
              <Typography
                style={{
                  color: 'white',
                  marginTop: 8,
                  fontSize: '14px',
                  textAlign: 'center',
                  maxWidth: '450px',
                }}
              >
                {currentPhoto.description}
              </Typography>
            )}
        </Box>
        {imagesArr.length > 0 && (
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              marginLeft: 16,
            }}
          >
            <Box
              className={'navigation-button'}
              style={{
                backgroundColor: 'white',
                width: 30,
                height: 30,
                borderRadius: 1000,
              }}
              sx={{
                cursor:
                  imageIndex !== imagesArr.length - 1 ? 'pointer' : 'default',
              }}
              onClick={() => {
                if (imageIndex !== imagesArr.length - 1)
                  setImageIndex(imageIndex + 1);
              }}
            >
              <img
                src={
                  imageIndex < imagesArr.length - 1
                    ? '/images/next-page.svg'
                    : '/images/next-page-disabled.svg'
                }
                style={{ height: '30px' }}
              />
            </Box>
          </Box>
        )}
      </Box>
    </Backdrop>
  );
}
